import { required, maxLength, range, nested } from '@rx/annotations';
import { CommunicationMode, ProjectEventTimeline,  vTheirTeamCommunicationModeRecord  } from '.'
export class NegotiationTimelineCommunicationMode {
    constructor(negotiationTimelineCommunicationMode?: NegotiationTimelineCommunicationMode )  {
        let properties = [ "negotiationTimelineCommunicationModeId", "communicationModeId", "projectEventTimelineId",];
        for (let property of properties)
            if (negotiationTimelineCommunicationMode && negotiationTimelineCommunicationMode[property])
                this[property] = negotiationTimelineCommunicationMode[property];
    }
 
	negotiationTimelineCommunicationModeId : number =   0 ;
 
    @range(0,2147483647)
	communicationModeId : number =   undefined;
	communicationMode : CommunicationMode  ;
 
    @range(0,2147483647)
	projectEventTimelineId : number =   undefined;
	projectEventTimeline : ProjectEventTimeline  ;


}



// WEBPACK FOOTER //
// ./src/app/database-models/negotiation-timeline-communication-mode.ts